import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FamilyServices.css';

const FamilyServices = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: 1,
      icon: '💞',
      title: 'Love & Compatibility',
      subtitle: 'Decode your relationship chemistry and connect on a deeper level.',
      features: [
        'Compatibility & soulmate readings',
        'Relationship strengths & growth zones',
        'Timing for love or marriage'
      ]
    },
    {
      id: 2,
      icon: '💍',
      title: 'Marriage & Long-Term Partnerships',
      subtitle: 'Understand your bond and strengthen long-term commitment.',
      features: [
        'Marriage timing & prospects',
        'Compatibility insights',
        'Remedies for harmony & balance'
      ]
    },
    {
      id: 3,
      icon: '🌿',
      title: 'Family Dynamics & Healing',
      subtitle: 'Heal generational patterns and nurture family harmony.',
      features: [
        'Family karma analysis',
        'Parent–child understanding',
        'Emotional energy healing for home balance'
      ]
    },
    {
      id: 4,
      icon: '👶',
      title: 'Parenting & Children\'s Astrology',
      subtitle: 'Support your child\'s growth through personalized cosmic guidance.',
      features: [
        'Child\'s chart & personality analysis',
        'Emotional nurturing insights',
        'Education & timing guidance'
      ]
    },
    {
      id: 5,
      icon: '🧘',
      title: 'Emotional & Karmic Harmony',
      subtitle: 'Heal emotional blocks and understand soul-level connections.',
      features: [
        'Karmic relationship readings',
        'Forgiveness & emotional healing',
        'Moon & Venus balance'
      ]
    },
    {
      id: 6,
      icon: '🕊️',
      title: 'Cycles & Relationship Forecast',
      subtitle: 'Navigate changes in love and family with clarity and timing.',
      features: [
        'Annual relationship forecast',
        'Conflict & harmony windows',
        'Ideal periods for connection or renewal'
      ]
    }
  ];

  return (
  <section className="bg-sand text-indigoDeep py-8">
      <div className="w-full px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="bg-bone/95 text-indigoDeep rounded-xl p-8 border border-gray-200 hover:border-gray-300 transition-all duration-300 hover:transform hover:scale-105 shadow-lg"
            >
              <div className="text-5xl mb-4">{service.icon}</div>
              <h3 className="font-serif text-2xl mb-2 text-indigoDeep">{service.title}</h3>
              <p className="text-grayWarm text-sm mb-6">{service.subtitle}</p>
              
              <div className="space-y-3">
                <p className="text-xs uppercase tracking-widest text-grayWarm font-semibold">Includes:</p>
                <ul className="space-y-2">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-start text-sm text-grayWarm">
                      <span className="text-goldSoft mr-3 mt-1">✦</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button 
                onClick={() => navigate('/booking')}
                className="w-full mt-8 bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-white font-semibold py-3 rounded-lg transition-all duration-300 transform hover:shadow-lg">
                Learn More
              </button>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center bg-white/5 backdrop-blur-md rounded-xl p-12 border border-white/10">
          <p className="text-indigoDeep text-xl mb-8 font-serif">
            Ready to strengthen your relationships and heal family bonds?
          </p>
          <button 
            onClick={() => navigate('/booking')}
            className="bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-white font-bold py-4 px-12 rounded-lg hover:shadow-2xl transition-all duration-300 text-lg transform hover:scale-105">
            💕 Schedule Your Relationship Reading
          </button>
        </div>
      </div>
    </section>
  );
};

export default FamilyServices;
